const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const esc = (s) => String(s).replace(/[&<>"']/g, (c) => `&#${c.charCodeAt(0)};`);
const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
const money = (cents, currency) =>
  new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
const colour = (name) => MM.colours[name] || {};
// Shopify image CDN: request any width by rewriting the width param
const sized = (url, w) => (/[?&]width=\d+/.test(url) ? url.replace(/width=\d+/, `width=${w}`) : `${url}${url.includes('?') ? '&' : '?'}width=${w}`);
const srcset = (url) => [300, 450, 600, 800, 1000, 1300, 1600, 2000, 2400].map((w) => `${sized(url, w)} ${w}w`).join(', ');

/* ---------- Cart drawer (Shopify AJAX cart) ---------- */
const drawer = $('[data-cart]');
let cart = null;

async function cartFetch(url, body) {
  const r = await fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : {});
  const data = await r.json();
  if (!r.ok) throw new Error(data.description || data.message || 'Could not update bag');
  return data;
}

function renderCart() {
  const count = cart.item_count, total = cart.items_subtotal_price;
  $$('[data-cart-count]').forEach((el) => (el.textContent = count));
  $('[data-cart-label]').textContent = count === 1 ? '1 item' : `${count} items`;
  $('[data-cart-total]').textContent = money(total, cart.currency);
  $('[data-cart-empty]').hidden = count > 0;
  $('[data-cart-items]').hidden = $('[data-cart-foot]').hidden = count === 0;
  $('[data-cart-items]').innerHTML = cart.items.map((it) => {
    const [c, size] = it.options_with_values.map((o) => o.value);
    const col = colour(c);
    const img = it.image ? sized(it.image, 240) : '';
    return `<div class="cart-item" data-key="${esc(it.key)}" data-qty="${it.quantity}">
      <div class="cart-thumb">${img ? `<img src="${esc(img)}" alt="${esc(c || it.product_title)}">` : ''}</div>
      <div class="cart-meta">
        <span class="cart-name">${esc(it.product_title)}</span>
        <span class="cart-var"><span class="dot" style="background:${esc(col.hex || 'transparent')}"></span>${esc([c, size].filter(Boolean).join(' · '))}</span>
        <div class="cart-ctl">
          <div class="qty"><button data-qty="-1" aria-label="Decrease">−</button><span>${it.quantity}</span><button data-qty="1" aria-label="Increase">+</button></div>
          <button class="cart-rm" data-qty="rm">Remove</button>
        </div>
      </div>
      <span class="cart-price">${money(it.final_line_price, cart.currency)}</span>
    </div>`;
  }).join('');
}

async function refreshCart(data) {
  cart = data || (await cartFetch('/cart.js'));
  renderCart();
}
const openCart = () => drawer.classList.add('is-open');
const closeCart = () => drawer.classList.remove('is-open');

async function addToCart(id) {
  await cartFetch('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
  await refreshCart();
  openCart();
}

$('[data-cart-items]').addEventListener('click', async (e) => {
  const b = e.target.closest('[data-qty]');
  if (!b) return;
  const row = b.closest('.cart-item');
  const q = b.dataset.qty === 'rm' ? 0 : Number(row.dataset.qty) + Number(b.dataset.qty);
  try { await refreshCart(await cartFetch('/cart/change.js', { id: row.dataset.key, quantity: q })); }
  catch (err) { $('[data-cart-label]').textContent = err.message; }
});

/* ---------- Global click handling ---------- */
const menu = $('[data-menu]');
document.addEventListener('click', async (e) => {
  const t = e.target;
  if (t.closest('[data-cart-open]')) openCart();
  else if (t.closest('[data-cart-close]')) closeCart();
  else if (t.closest('[data-menu-open]')) menu.hidden = false;
  else if (t.closest('[data-menu-close]') || t.closest('[data-menu] a')) menu.hidden = true;
  else if (t.closest('[data-sizes-open]')) {
    const tile = t.closest('[data-tile]');
    $$('[data-tile]').forEach((x) => toggleSizes(x, x === tile));
  } else if (t.closest('[data-sizes-close]')) toggleSizes(t.closest('[data-tile]'), false);
  else if (t.closest('[data-add]')) {
    const b = t.closest('[data-add]'), tile = b.closest('[data-tile]');
    try { await addToCart(b.dataset.add); toggleSizes(tile, false); }
    catch (err) { $('.tile-sizes-head span', tile).textContent = err.message; }
  }
});
function toggleSizes(tile, open) {
  const s = $('[data-sizes]', tile);
  if (!s) return;
  s.hidden = !open;
  $('[data-sizes-open]', tile).hidden = open;
}
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') { closeCart(); menu.hidden = true; }
});

refreshCart().catch(() => {});

/* ---------- Home tiles: close-up loads on first hover only (touch screens never pay for it) ---------- */
document.addEventListener('pointerover', (e) => {
  const tpl = e.pointerType === 'mouse' && e.target.closest('.tile-link')?.querySelector('template[data-hover-img]');
  if (tpl) tpl.replaceWith(tpl.content.cloneNode(true));
});

/* ---------- Home hero: scroll-driven colour wipe ---------- */
function initHero() {
  const stage = $('[data-stage]');
  if (stage) {
    const box = $('[data-layers]', stage), line = $('[data-line]', stage);
    const layers = $$('[data-layer]', box);
    const n = layers.length, pad = (i) => String(i).padStart(2, '0');
    const dots = $('[data-dots]', stage);
    dots.innerHTML = layers.map((l, i) => `<button title="${esc(l.dataset.name)}" data-go="${i}" style="background:${esc(l.dataset.hex)}"></button>`).join('');
    let idx = -1, frame = 0;

    const setIdx = (i) => {
      if (i === idx) return;
      idx = i;
      $('[data-counter]', stage).textContent = `${pad(i + 1)} / ${pad(n)}`;
      $('[data-hero-name]', stage).textContent = layers[i].dataset.name;
      box.title = `Shop ${layers[i].dataset.name}`;
      $$('button', dots).forEach((d, k) => d.setAttribute('aria-current', k === i));
    };

    // Writes clip-paths straight to the DOM on each animation frame.
    const paint = () => {
      frame = 0;
      const total = stage.offsetHeight - window.innerHeight;
      const t = clamp(-stage.getBoundingClientRect().top / total, 0, 1) * (n - 1);
      const seg = clamp(Math.floor(t), 0, Math.max(n - 2, 0));
      const u = clamp(t - seg, 0, 1);
      const e = u < 0.5 ? 2 * u * u : 1 - Math.pow(-2 * u + 2, 2) / 2;
      const split = 100 - 100 * e;
      if (n > 1) layers.forEach((k, i) => {
        k.style.clipPath = i === seg ? `inset(0 ${100 - split}% 0 0)` : i === seg + 1 ? `inset(0 0 0 ${split}%)` : 'inset(0 0 0 100%)';
      });
      line.style.left = `${split}%`;
      line.style.opacity = split > 0.5 && split < 99.5 ? '0.3' : '0';
      setIdx(e < 0.5 ? seg : Math.min(seg + 1, n - 1));
      $('[data-hint]', stage).style.opacity = t < 0.05 ? 1 : 0;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(paint); };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    paint();

    dots.addEventListener('click', (e) => {
      const b = e.target.closest('[data-go]');
      if (!b) return;
      const total = stage.offsetHeight - window.innerHeight;
      window.scrollTo({ top: stage.offsetTop + (b.dataset.go / Math.max(n - 1, 1)) * total, behavior: 'smooth' });
    });
    const go = () => { location.href = layers[idx].dataset.href; };
    box.addEventListener('click', go);
    box.addEventListener('keydown', (e) => { if (e.key === 'Enter') go(); });
  }
}
initHero();
// ponytail: theme editor re-renders the section without a reload; old scroll listeners stay but only touch detached nodes
document.addEventListener('shopify:section:load', initHero);

/* ---------- Product page ---------- */
const pdp = $('[data-pdp]');
if (pdp) {
  const variants = JSON.parse($('[data-pdp-variants]').textContent);
  const sel = JSON.parse($('[data-pdp-selected]').textContent);
  const addBtn = $('[data-pdp-add]', pdp), barBtn = $('[data-bar-btn]');
  const media = JSON.parse($('[data-pdp-media]').textContent);
  const gallery = $('.pdp-gallery', pdp), flat = $('[data-shot=flat]', pdp), detail = $('[data-shot=detail]', pdp);
  let shownColour = sel.c;
  const guide = $('[data-guide]'), sheet = $('[data-sheet]'), lb = $('[data-lb]');
  const current = () => variants.find((x) => x.c === sel.c && x.s === sel.s);
  let lbIdx = 0;

  const update = () => {
    const col = colour(sel.c), v = current();
    if (sel.c !== shownColour && media[sel.c] && flat && detail) {
      shownColour = sel.c;
      gallery.classList.add('is-loading');
      let left = 2;
      const done = () => { if (--left === 0) gallery.classList.remove('is-loading'); };
      [[flat, sel.c], [detail, `${sel.c} close-up`]].forEach(([img, key]) => {
        img.onload = img.onerror = done;
        img.srcset = srcset(media[key]);
        img.src = media[key];
        img.alt = key;
      });
      // lifestyle photo (theme asset, from snippets/colours.liquid); some colours have none
      const life = $('[data-life]', pdp);
      life.hidden = !col.life;
      life.innerHTML = col.life ? `<img src="${esc(sized(col.life, 1000))}" srcset="${esc(srcset(col.life))}" sizes="(max-width: 639px) 86vw, (max-width: 1023px) 50vw, 55vw" alt="${esc(sel.c)}, worn">` : '';
    }
    $('[data-pdp-colour]', pdp).textContent = sel.c;
    $('[data-bar-name]').textContent = sel.c;
    $('[data-bar-dot]').style.background = col.hex || 'transparent';
    $$('[data-colour]', pdp).forEach((b) => b.setAttribute('aria-pressed', b.dataset.colour === sel.c));
    const sizeState = (b, s) => {
      const x = variants.find((y) => y.c === sel.c && y.s === s);
      b.disabled = !x || !x.a;
      b.setAttribute('aria-pressed', s === sel.s);
    };
    $$('[data-size]', pdp).forEach((b) => sizeState(b, b.dataset.size));
    $$('[data-sheet-size]').forEach((b) => sizeState(b, b.dataset.sheetSize));
    $$('[data-size-pick]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.sizePick === sel.s));
    $('[data-pdp-id]', pdp).value = v ? v.id : '';
    const ok = v && v.a;
    addBtn.setAttribute('aria-disabled', !ok);
    addBtn.textContent = !sel.s ? 'Select a size' : ok ? `Add to bag — ${sel.c}, ${sel.s}` : 'Sold out';
    barBtn.textContent = !sel.s ? 'Select size' : ok ? `Add to bag · ${sel.s}` : 'Sold out';
    const shown = v || variants.find((x) => x.c === sel.c);
    if (shown) {
      $('[data-pdp-price]', pdp).textContent = $('[data-bar-price]').textContent = money(shown.p, MM.currency);
      history.replaceState(null, '', shown.u); // variants can live on either family product
    }
  };

  const add = async (label) => {
    const v = current();
    if (!v || !v.a) return;
    try { await addToCart(v.id); }
    catch (err) { label.textContent = err.message; }
  };

  const showLb = (i) => {
    lbIdx = i;
    const key = i ? `${sel.c} close-up` : sel.c;
    const box = $('[data-lb-img]', lb);
    box.className = `lb-img${i ? ' is-detail' : ''}`;
    box.innerHTML = media[key] ? `<img src="${esc(sized(media[key], 1600))}" srcset="${esc(srcset(media[key]))}" sizes="(max-aspect-ratio: 5/7) 96vw, 69vh" alt="${esc(key)}">` : '';
    $('[data-lb-label]', lb).textContent = `${sel.c} · ${i + 1} / 2`;
    lb.hidden = false;
  };

  document.addEventListener('click', (e) => {
    const t = e.target, c = t.closest('[data-colour]'), s = t.closest('[data-size]');
    if (c) { sel.c = c.dataset.colour; update(); }
    else if (s) { sel.s = s.dataset.size; update(); }
    else if (t.closest('[data-size-pick]')) { sel.s = t.closest('[data-size-pick]').dataset.sizePick; update(); }
    else if (t.closest('[data-unit-pick]')) guide.dataset.unit = t.closest('[data-unit-pick]').dataset.unitPick;
    else if (t.closest('[data-guide-open]')) { sheet.hidden = true; guide.hidden = false; }
    else if (t.closest('[data-guide-close]')) guide.hidden = true;
    else if (t.closest('[data-sheet-close]')) sheet.hidden = true;
    else if (t.closest('[data-sheet-size]')) { sel.s = t.closest('[data-sheet-size]').dataset.sheetSize; sheet.hidden = true; update(); add(barBtn); }
    else if (t.closest('[data-bar-btn]')) { if (current()) add(barBtn); else sheet.hidden = false; }
    else if (t.closest('[data-lb-open]')) showLb(Number(t.closest('[data-lb-open]').dataset.lbOpen));
    else if (t.closest('[data-lb-step]')) showLb(1 - lbIdx);
    else if (t.closest('[data-lb-close]')) lb.hidden = true;
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { guide.hidden = sheet.hidden = lb.hidden = true; }
    if (!lb.hidden && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) showLb(1 - lbIdx);
  });
  // sticky bar only while the in-page add button is off screen
  new IntersectionObserver(([e]) => barBtn.closest('.pdp-bar').classList.toggle('is-on', !e.isIntersecting)).observe(addBtn);
  $('[data-pdp-form]', pdp).addEventListener('submit', (e) => { e.preventDefault(); add(addBtn); });
  update();
}

/* ---------- Help: withdrawal form ---------- */
document.addEventListener('click', (e) => {
  const open = e.target.closest('[data-withdraw-open]'), cancel = e.target.closest('[data-withdraw-cancel]');
  if (!open && !cancel) return;
  $('[data-withdraw-start]').hidden = !!open;
  $('[data-withdraw-form]').hidden = !open;
});
